import {
  isLocalDatabaseRootDocId,
  isServerDatabaseRootDocId,
  isServerDatabaseRowShardDocId,
} from '@streamlain/database-identity';

export function isDatabaseRootCollectionDocId(
  docId: string,
  workspaceId: string
): boolean {
  return (
    isLocalDatabaseRootDocId(docId) ||
    isServerDatabaseRootDocId(docId, workspaceId)
  );
}

export function isDatabaseRowShardCollectionDocId(
  docId: string,
  workspaceId: string
): boolean {
  return isServerDatabaseRowShardDocId(docId, workspaceId);
}

export function isDatabaseSystemCollectionDocId(
  docId: string,
  workspaceId: string
): boolean {
  return (
    isDatabaseRootCollectionDocId(docId, workspaceId) ||
    isDatabaseRowShardCollectionDocId(docId, workspaceId)
  );
}
